module.exports = __webpack_public_path__ + "static/media/class_job_009.1c994177.svg";